import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './ghana-ticker-tape.component.scss';
var GhanaTickerTape = /** @class */ (function (_super) {
    tslib_1.__extends(GhanaTickerTape, _super);
    function GhanaTickerTape(element) {
        return _super.call(this, element) || this;
    }
    GhanaTickerTape.prototype.init = function () {
    };
    GhanaTickerTape.prototype.bindEvents = function () {
    };
    return GhanaTickerTape;
}(Base));
export { GhanaTickerTape };



//////////////////
// WEBPACK FOOTER
// ./components/ghana-ticker-tape/ghana-ticker-tape.component.ts
// module id = 767
// module chunks = 0